export const trimText = (text, length) => {
    if (text.length <= length) return text;
    return text.slice(0, length) + '...';
};

const POKEMON_REGEX = /pokemon/gi;

const applyPokemonBranding = (value) => {
    return value.replace(POKEMON_REGEX, (match) => {
        if (match === match.toUpperCase()) return 'POKÉMON';
        if (
            match[0] === match[0].toUpperCase() &&
            match.slice(1) === match.slice(1).toLowerCase()
        ) {
            return 'Pokémon';
        }

        return 'pokémon';
    });
};

export const formatCategoryText = (text) => {
    if (!text) return '';

    return applyPokemonBranding(text);
};
